<template>

  <div id="loginPage">
    <el-row>
      <el-col :span="24" align="center">
        <div class="logo-bg">
          <el-dropdown @command="handleCommand">
            
            <span class="el-dropdown-link">
              {{lang}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh">中文</el-dropdown-item>
              <el-dropdown-item command="ja">日本語</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" align="center">
        <div class="main-bg">
          <div class="slogan">EnRobot Cloud</div>
          <div class="slogan-info">
            {{$t('login.slogan')}}<br>
          </div>

          <transition name="el-fade-in-linear">
          
            <div id="loginForm" v-show="show">
              <el-form ref="ruleForm" :model="ruleForm" :rules="rules" style="margin-top: 30px;">
                <el-form-item label="" prop="userName">
                
                  <el-input
                    :placeholder="$t('login.username')"
                    v-model="ruleForm.userName"
                    clearable
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="" prop="password">
                  <el-input
                    :placeholder="$t('login.password')"
                    v-model="ruleForm.password"
                    show-password
                    clearable
                  >
                  </el-input>
                </el-form-item>
              
                <el-form-item style="text-align:center;">
                  <el-button
                    type="primary"
                    @click="submitRuleForm('ruleForm')"
                    style="width:100%" 
                    round
                    >{{$t('login.login')}}</el-button
                  >
                  <div class="forgetPassword"><router-link :to="ROUTER_PATH.ACCOUNT_FORGET_PASSWORD" class="el-link el-link--default ">
                    {{$t('login.forgetPwd')}}
                    </router-link></div>
                </el-form-item>
              </el-form>
            </div>

          </transition>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" align="center">
        <div class="footer">
          ©️2020 上海易氩软件有限公司&nbsp;&nbsp; <a style="color:#fff" href="http://www.shca.gov.cn/">沪ICP备19021575号-2</a>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { login } from "@/api/account";
import { mapState, mapMutations } from "vuex";
import { mutationsType } from "@/store/mutations-type.js";
import { LOCAL_STORAGE_KEY } from "@/constants/common.js";
import { isNullOrUndefinedOrEmpty } from "@/utils/stringHelper.js";
import { ROUTER_PATH } from "@/constants/common.js";
//import CookieUtil from "@/utils/cookie.js";


export default {
  name: "Login",
  data: () => {
    //var e1 = this.$t('err1');
    //var e2 = this.$t('err2');
    return {
      ROUTER_PATH: ROUTER_PATH,
      ruleForm: {
        userName: "",
        password: ""
      },
      show: true,
      lang: "",
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }]
        }
      }
    
  },
  mounted() {
    //this.lang = CookieUtil.getCookie('lang') == null ? 'zh' : CookieUtil.getCookie('lang');
    this.lang = "中文";
    this.$i18n.locale = "zh";
    if (
      !isNullOrUndefinedOrEmpty(
        localStorage.getItem(LOCAL_STORAGE_KEY.RPA_TOKEN)
      ) &&
      !isNullOrUndefinedOrEmpty(
        localStorage.getItem(LOCAL_STORAGE_KEY.RPA_USER_ID)
      )
    ) {
      this.$router.push(ROUTER_PATH.HOME);
    }

    if((navigator.language || navigator.browserLanguage).toLowerCase().includes('zh')) {
        this.$cookies.set("language", "zh", 60 * 60 * 24 * 30);
        this.$i18n.locale = "zh";
        this.lang = "中文";
     } else if((navigator.language || navigator.browserLanguage).toLowerCase().includes('ja')) {
        this.$cookies.set("language", "ja", 60 * 60 * 24 * 30);
        this.$i18n.locale = "ja";
        this.lang = "日本語";

    }
    
  },
  methods: {
    ...mapMutations([mutationsType.INIT_ACCOUNT_INFO]),
    submitRuleForm(ruleFormName) {
      this.$refs[ruleFormName].validate(valid => {
        if (valid) {
          login({
            ...this.ruleForm
          }).then(response => {
            this.$message({
              type: "success",
              message: response.message
            });
            localStorage.setItem(
              LOCAL_STORAGE_KEY.RPA_TOKEN,
              response.data.token
            );
            localStorage.setItem(
              LOCAL_STORAGE_KEY.RPA_USER_ID,
              response.data.userID
            );
            localStorage.setItem(
              LOCAL_STORAGE_KEY.RPA_TOKEN_EXPIRE,
              Date.now() + 24*60*60*1000
            );

            this.$router.push(
              isNullOrUndefinedOrEmpty(this.loginPrePath)
                ? ROUTER_PATH.HOME
                : this.loginPrePath
            );
          });
        } else {
          return false;
        }
      });
    },
    handleCommand(command) {
      if (command == "zh") {
        this.lang = "中文";
        this.$i18n.locale = "zh";
        //this.$cookie.set("lang","zh");
      } else {
        this.lang = "日本語";
        this.$i18n.locale = "ja";
        //this.$cookie.set("lang","jp");
      }
    }
    

  },
  computed: {
    ...mapState(["loginPrePath"])
  }
};
</script>

<style>
#loginPage {
  display: flex;
  height: 100%;
  background-color: #fff;
  flex-direction: column;
}
#loginPage .container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
#loginForm {
  box-sizing: border-box;
  width: 500px;
  height: 300px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  top:-100px;
  left:360px;
  position:relative;
  background-color: #fff;
}

#loginForm .forgetPassword{
  margin:0px 0px 10px 0px;
  text-align: right;
}

.logo-bg {
  background-image: url(../../assets/images/logo_m.png);
  background-repeat: no-repeat;
  background-size: 140px 45px;
  width: 80%;
  height: 45px;
  margin-top: 35px;
  text-align: right;
}

.main-bg {
  background-image: url(../../assets/images/image1.png);
  background-repeat: no-repeat;
  background-size: 100%;
  width: 90%;
  height: 600px;
  margin-top: 30px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.09);
}

.footer { 
  width:90%;
  text-align: center;
  line-height: 35px;
  height: 35px;
  background-color: #333a40;
  color: #fff;
  font-size: 12px;
}

.slogan { 
  font-size: 36px;
  font-weight: bolder;
  color: #0B7CC4;
  top:120px;
  left:-340px;
  position:relative;
}

.slogan-info { 
  font-size: 18px;
  color: #333a40;
  top:170px;
  left:-230px;
  position:relative;
  text-align: left;
  width: 500px;
  line-height: 26px;
}

.text-center{
  text-align: center;
}

.transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }

</style>
